import { DefaultState } from 'store/types';
import { RoomGuestReservationData } from 'types/rooms/room-guest';

export const GET_READY_FOR_ASSIGNMENT_REQUEST = 'GET_READY_FOR_ASSIGNMENT_REQUEST';
export const GET_READY_FOR_ASSIGNMENT_SUCCESS = 'GET_READY_FOR_ASSIGNMENT_SUCCESS';
export const GET_READY_FOR_ASSIGNMENT_FAILURE = 'GET_READY_FOR_ASSIGNMENT_FAILURE';

export interface GetReadyForAssignmentData {
  ids: string[];
};

export interface ReadyForAssignmentData {
  id: string;
  name: string;
  fromDate: string;
  toDate: string;
  gender: string;
  status: string;
  reservationData: RoomGuestReservationData;
}

export type GetReadyForAssignmentDataState = DefaultState & {
  contents?: ReadyForAssignmentData[];
};

interface ReadGetReadyForAssignmentRequest {
  type: typeof GET_READY_FOR_ASSIGNMENT_REQUEST;
};

interface ReadGetReadyForAssignmentSuccess {
  type: typeof GET_READY_FOR_ASSIGNMENT_SUCCESS,
  contents: ReadyForAssignmentData[];
}

interface ReadGetReadyForAssignmentFailure {
  type: typeof GET_READY_FOR_ASSIGNMENT_FAILURE;
}

export type GetReadyForAssignmentActionTypes = ReadGetReadyForAssignmentRequest | ReadGetReadyForAssignmentSuccess | ReadGetReadyForAssignmentFailure;